import PrimarySpinner from 'global/Loading/PrimarySpinner';
import If from 'global/ErrorHandlers/If';

import ModalShare from 'global/ModalShare';
import Community from './components/Community';
import JoinCommunity from './components/JoinCommunity';
import useCheckStatus from './hooks/useCheckStatus';
import { useShareReceipt } from './hooks/useShareReceipt';

function CommunityFeature() {
  const { data, refetch, isError, isSuccess, isLoading, isFetching } =
    useCheckStatus();

  const isVisible = useShareReceipt((store) => store.isShareModalVisible);
  const recipientName = useShareReceipt((store) => store.recipientName);
  const message = useShareReceipt((store) => store.message);
  const sendChat = useShareReceipt((store) => store.sendChat);
  const hideShareModal = useShareReceipt((store) => store.hideShareModal);

  if (!isLoading) {
    return (
      <>
        <If condition={isSuccess}>
          <Community data={data} refetch={refetch} />;
        </If>
        <If condition={isError}>
          <JoinCommunity />
        </If>
        <ModalShare
          onCancel={hideShareModal}
          sendChat={sendChat}
          title="Share"
          recipientName={recipientName}
          visible={isVisible}
          defaultSharedMessage={message}
          hasSingleRecipient
        />
      </>
    );
  }

  return (
    <PrimarySpinner isLoading={isFetching || isLoading} overlay isDarkOverlay />
  );
}

export default CommunityFeature;
